import { DataTable, TableProvider, Grid } from '@cxc/react-fpds-components';
import TableProps from '../../types/props/TableProps';

const Table = ({ headerValues, rowValues, style, paginationProps }: TableProps) => {
    const DEFAULT_PAGINATION_PROPS = {
        isPaginationEnabled: true,
        tablePage: 1,
        itemsPerPage: 10,
    };
    const pagination = paginationProps ? paginationProps : DEFAULT_PAGINATION_PROPS;
    return (
        <Grid>
            <Grid.Item style={style} xl={12} l={12} m={12} s={12}>
                <TableProvider>
                    <DataTable
                        isCheckboxEnabled={false}
                        isOptionProps={{ isOptionsEnabled: false }}
                        isStickyColumnEnabled={false}
                        paginationProp={pagination}
                        headerValues={headerValues}
                        rowValues={rowValues}
                    />
                </TableProvider>
            </Grid.Item>
        </Grid>
    );
};

export default Table;
